<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-app>
    <v-app-bar app color="primary" dark clipped-right>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="@/assets/canchaeasy.png"
          transition="scale-transition"
          width="s"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        v-if="user"
        @click="getPastBookings(user.id, 2024, 10)"
        :color="showAllUsers ? 'lightgray' : 'blue'"
        class="mr-4"
      >
        <v-icon>mdi-account-group</v-icon>
        <span class="ml-2">Reservas pasadas</span>
      </v-btn>

      <v-btn
        v-if="user"
        @click="getAllUsers()"
        :color="showAllUsers ? 'lightgray' : 'blue'"
        class="mr-4"
      >
        <v-icon>mdi-account-group</v-icon>
        <span class="ml-2">Carnets activos</span>
      </v-btn>

      <v-btn
        @click="showLogs = !showLogs"
        :color="showLogs ? 'lightgray' : 'red'"
      >
        <v-icon>mdi-cog</v-icon>
        <span class="ml-2">Logs</span>
      </v-btn>

      <v-btn v-if="user" @click="logout()" class="ml-4">
        <v-icon>mdi-account-circle</v-icon>
        <span class="ml-2 mr-4">Hola {{ user.first_name }}!</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-if="showLogs"
      app
      expand-on-hover
      permanent
      right
      clipped
      width="60%"
    >
      <v-container>
        <v-row>
          <v-col>
            <p>LOGS</p>
            <div v-for="(log, index) in logs" :key="index">
              <v-card class="mt-2 mb-2" :color="log.type">
                <div class="font-weight-bold">
                  {{ log.title }} - Method: {{ log.from }} - Timestamp:
                  {{ log.timestamp }}
                </div>
                <VueObjectView :value="log.msg"></VueObjectView>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-main>
      <v-container v-if="!user">
        <v-row>
          <v-col>
            <v-text-field
              v-model="username"
              label="Usuario"
              filled
              class="shrink"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="password"
              label="Clave"
              filled
              type="password"
              class="shrink"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="green lighten-2" class="mr-4" @click="login()"
              >Ingresar</v-btn
            >
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="user">
        <v-row>
          <v-col>
            <v-icon large color="blue darken-2">mdi-clock</v-icon>
            <div class="text-h3 mb-6">{{ currentTime }} hs.</div>
          </v-col>
        </v-row>
        <v-form v-model="formValid" ref="form">
          <v-row>
            <v-col lg="3" md="6" sm="12" xs="12" cols="12"
              >Reservar la
              <v-select
                v-model="courtSelected"
                :items="courts"
                item-text="name"
                item-value="id"
                label="Cancha"
                filled
                dense
                required
                :rules="requiredRule"
                @change="validateForm()"
              ></v-select>
              <v-switch
                v-model="secondaryCourt"
                label="O cualquier otra cancha disponible"
                class="ma-0"
                color="green"
                prepend-icon="mdi-radar"
                inset
              ></v-switch>
            </v-col>
            <v-col lg="3" md="6" sm="12" xs="12" cols="12">
              Para el día
              <v-select
                v-model="dateSelected"
                :items="allowedDates"
                :item-text="allowedDates.text"
                :item-value="allowedDates.value"
                label="Fecha"
                filled
                dense
                required
                :rules="requiredRule"
                @change="validateForm()"
              ></v-select>
            </v-col>
            <v-col lg="3" md="6" sm="12" xs="12" cols="12">
              En el horario de las
              <v-select
                v-model="hourSelected"
                :items="allowedHours"
                :item-text="allowedHours.text"
                :item-value="allowedHours.value"
                label="Hora"
                filled
                dense
                required
                :rules="requiredRule"
                @change="validateForm()"
              ></v-select>
            </v-col>
            <v-col lg="3" md="6" sm="12" xs="12" cols="12">
              Usando los carnets de
              <v-select
                v-model="relationsSelected"
                :items="relations"
                :item-text="relations.text"
                :item-value="relations.value"
                multiple
                filled
                required
                :rules="threeItemsSelected"
                chips
                no-data-text="No hay carnets asociados en la sección de Mis Amigos en la App Hacoaj."
                hint="Administre los carnets asociados desde la seccion de Mis Amigos en la App Hacoaj."
                persistent-hint
                @change="validateForm()"
                @blur="validateForm()"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="mt-6">
          <v-col class="pa-0">
            <v-layout justify-end>
              <v-switch
                v-model="activeScheduler"
                :disabled="!allowedScheduler"
                class="ma-0"
                color="green"
                prepend-icon="mdi-alarm-check"
                inset
              ></v-switch>
            </v-layout>
          </v-col>
          <v-col class="pa-0">
            <v-layout justify-start> Autoreservar (+ {{ minDelay }}s)</v-layout>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col class="pa-0">
            <v-layout justify-end>
              <v-switch
                v-model="delayScheduler"
                :disabled="!activeScheduler"
                class="ma-0"
                color="green"
                prepend-icon="mdi-alarm-plus"
                inset
              ></v-switch>
            </v-layout>
          </v-col>
          <v-col class="pa-0">
            <v-layout justify-start>
              Demora aleatoria ({{ randomDelay[0] }}s y
              {{ randomDelay[1] }}s)</v-layout
            >
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col>
            <v-btn
              @click="book()"
              :disabled="!formValid || activeScheduler"
              color="green lighten-2"
              :loading="bookingLoading"
              >Reservar Mi CanchaEasy</v-btn
            >
          </v-col>
        </v-row>
        <v-row class="mt-16">
          <v-col>
            <v-icon large color="blue darken-2">mdi-calendar</v-icon>
            <div class="text-h4 mb-6"> Estado de reservas para el {{ formatDate(scheduledDate) }}</div>
            Ultima actualización {{ lastScheduleGet }} - Actualizar <v-icon color="blue darken-2" @click="getSchedule(scheduledDate)">mdi-refresh</v-icon>
          </v-col>
        </v-row>        
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" xl="10">
            <v-data-table
              :headers="scheduledHeader"
              :items="scheduledItems"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              disable-sort
              locale="es-ES"
            >
              <template v-slot:item.slot1000="{ item }">
                <v-tooltip top v-if="item.slot1000">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1000 ? item.slot1000.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1000 ? item.slot1000.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1000 ? item.slot1000.player : '??' }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.slot1100="{ item }">
                <v-tooltip top v-if="item.slot1100">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1100 ? item.slot1100.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1100 ? item.slot1100.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1100 ? item.slot1100.player : '??' }}</span>
                </v-tooltip>
              </template>              

              <template v-slot:item.slot1200="{ item }">
                <v-tooltip top v-if="item.slot1200">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1200 ? item.slot1200.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1200 ? item.slot1200.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1200 ? item.slot1200.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1300="{ item }">
                <v-tooltip top v-if="item.slot1300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1300 ? item.slot1300.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1300 ? item.slot1300.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1300 ? item.slot1300.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1400="{ item }">
                <v-tooltip top v-if="item.slot1400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1400 ? item.slot1400.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1400 ? item.slot1400.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1400 ? item.slot1400.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1500="{ item }">
                <v-tooltip top v-if="item.slot1500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1500 ? item.slot1500.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1500 ? item.slot1500.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1500 ? item.slot1500.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1540="{ item }">
                <v-tooltip top v-if="item.slot1540">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1540 ? item.slot1540.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1540 ? item.slot1540.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1540 ? item.slot1540.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1600="{ item }">
                <v-tooltip top v-if="item.slot1600">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1600 ? item.slot1600.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1600 ? item.slot1600.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1600 ? item.slot1600.player : '??' }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.slot1620="{ item }">
                <v-tooltip top v-if="item.slot1620">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1620 ? item.slot1620.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1620 ? item.slot1620.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1620 ? item.slot1620.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1700="{ item }">
                <v-tooltip top v-if="item.slot1700">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs" v-on="on"
                        :color="item.slot1700 ? item.slot1700.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1700 ? item.slot1700.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1700 ? item.slot1700.player : '??' }}</span>
                </v-tooltip>
              </template>     

              <template v-slot:item.slot1800="{ item }">
                <v-tooltip top v-if="item.slot1800">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-if="item.slot1800"
                        v-bind="attrs" v-on="on"
                        :color="item.slot1800 ? item.slot1800.color : 'grey lighten-5'"
                        dark
                        label
                      >
                        {{ item.slot1800 ? item.slot1800.group : 'Disponible' }}
                      </v-chip>
                  </template>
                  <span>{{ item.slot1800 ? item.slot1800.player : '??' }}</span>
                </v-tooltip>
              </template>     
                                                                          
            </v-data-table>
            <div class="mt-4 caption">
              <v-tooltip top max-width="80%" v-for="group in groups">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      v-bind="attrs" v-on="on"
                      :color="group.color"
                      dark
                      label
                      class="ma-1"
                    >
                    {{ group.group }} = {{ group.groupDesc }} ({{ getPlayersFromGroup(group.group).length }})
                    </v-chip>
                </template>
                <span>{{ getPlayersFromGroup(group.group) }}</span>
              </v-tooltip>
            </div>

          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" xl="2">
            <v-date-picker v-model="scheduledDate" :allowed-dates="allowedScheduledDates" @change="getSchedule(scheduledDate)"></v-date-picker>
          </v-col>          
        </v-row>
      </v-container>

      <v-dialog v-model="bookingResultDialog" persistent max-width="600">
        <v-card>
          <v-card-title class="text-h5"> Resultado de la Reserva </v-card-title>
          <v-card-text>{{ bookingResultMessage }}</v-card-text>
          <v-icon @click="copyText(bookingResultMessage)"
            >mdi-clipboard-multiple</v-icon
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="bookingResultDialog = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showAllUsers" max-width="600">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th colspan="2">
                  <h2>Total carnets: {{ allUsers.length }}</h2>
                </th>
              </tr>
              <tr>
                <th class="text-left">
                  Nombre
                </th>
                <th class="text-left">
                  ID
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in allUsers"
                :key="item.id"
              >
                <td>{{ item.name }}</td>
                <td>{{ item.id }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-dialog>

      <v-overlay :value="bookingLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <div class="text-h5 mt-8 pt-6">{{ overlayMessage }}</div>
      </v-overlay>
      <v-snackbar v-model="snackbarShow" :color="snackbar.color">
        {{ snackbar.text }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import VueJwtDecode from "vue-jwt-decode";
import VueObjectView from "vue-object-view";
import gpjson from "@/assets/group_players.json";
import gjson from "@/assets/groups.json";

export default {
  name: "App",

  components: {
    VueObjectView,
  },

  data: () => ({
    endpoint: "",
    validUsers: [
      "ariel.kanelson@gmail.com",
      "tassaramar@gmail.com",
      "sebikaiser@gmail.com",
      "rleandro@gmail.com",
      "dsmalinsky@gmail.com"
    ],
    username: "",
    password: "",
    token: null,
    user: null,
    logs: [],
    showLogs: false,
    club: 959,
    sport: 644,
    courts: [
      { name: "Cancha 1", id: 11221 },
      { name: "Cancha 2", id: 11222 },
      { name: "Cancha 3", id: 11223 },
      { name: "Cancha 4", id: 11224 },
      { name: "Cancha 5", id: 11225 },
      { name: "Cancha 6", id: 12940 },
    ],
    bookingLoading: false,
    overlayMessage: "",
    courtSelected: null,
    secondaryCourt: true,
    dateSelected: null,
    allowedDates: [],
    hourSelected: null,
    start_time: null,
    end_time: null,
    timespan: null,
    allowedHours: [],
    relations: [],
    relationsSelected: [],
    formValid: false,
    requiredRule: [(v) => !!v || "Seleccione un valor"],
    threeItemsSelected: [(v) => v.length == 3 || "Seleccione 3 carnets."],
    currentTime: null,
    interval: null,
    allowedScheduler: false,
    activeScheduler: false,
    delayScheduler: false,
    randomDelay: [0, 1],
    minDelay: 1,
    snackbarShow: false,
    snackbar: {
      text: "Su reserva fue realizada con éxito!",
      color: "green",
    },
    availability: null,
    bookingResultDialog: false,
    bookingResultMessage: "",
    scheduledHeader: [],
    scheduledItems: [],
    scheduledDate: new Date().toISOString().split('T')[0],
    lastScheduleGet: new Date().toLocaleString('es-AR', {timeZone: 'America/Buenos_Aires'}),
    groups: [],
    showAllUsers: false,
    allUsers: [],
  }),

  watch: {
    activeScheduler(val) {
      if (!val) {
        this.delayScheduler = false;
      } else {
        this.delayScheduler = true;
      }
    },

    dateSelected() {
      this.getAllowedHours();
      this.scheduledDate = this.dateSelected;
      this.getSchedule(this.scheduledDate);
    },
  },

  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval);
  },
  created() {
    this.getCurrentHost();
    this.setPlayersGroups();
    this.getGroups();
    this.getScheduledHeader();
    // this.getSchedule(this.scheduledDate);
    // update the time every second.
    this.interval = setInterval(() => {
      this.currentTime = new Intl.DateTimeFormat(navigator.language, {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
      }).format();
      
      if (this.user && this.formValid) {
        // Check to trigger auto booking.
        if (
          this.allowedScheduler &&
          this.activeScheduler &&
          this.formValid &&
          this.currentTime == this.hourSelected
        ) {
          let random = this.minDelay * 1000;
          if (this.delayScheduler) {
            // Adds some random time ...
            random =
              this.minDelay * 1000 +
              Math.floor(
                Math.random() *
                  (this.randomDelay[1] * 1000 -
                    this.randomDelay[0] * 1000 +
                    1) +
                  this.randomDelay[0] * 1000
              );
          }
          this.overlayMessage =
            "Esperando " + String(random) + "ms antes de hacer la reserva ...";
          this.bookingLoading = true;
          setTimeout(() => {
            this.setLog({
              from: "scheduler",
              type: "success",
              msg: "Triggering scheduler ....",
            });
            this.setLog({
              from: "scheduler",
              type: "success",
              msg: "Waiting " + String(random) + " miliseconds ....",
            });
            this.overlayMessage = "";
            this.bookingLoading = false;
            this.book();
          }, random);
        }
        // Allow activate scheduler.
        if (this.currentTime < this.hourSelected) {
          this.allowedScheduler = true;
        } else {
          this.allowedScheduler = false;
        }
      }
    }, 1000);
  },

  mounted() {
    this.getAllowedDates();
  },

  methods: {

    allowedScheduledDates(date) {
      if (parseInt(new Date(date).getDay()) < 5 ) {
        return false;
      }
      return true;
    },

    getScheduledHeader() {
      this.scheduledHeader = [
        {
          text: this.formatDate(this.scheduledDate),
          value: 'courtName',
        },
        {
          text: '10:00',
          value: 'slot1000',
        },
        {
          text: '11:00',
          value: 'slot1100',
        },
        {
          text: '12:00',
          value: 'slot1200',
        },
        {
          text: '13:00',
          value: 'slot1300',
        },
        {
          text: '14:00',
          value: 'slot1400',
        },
        {
          text: '15:00',
          value: 'slot1500',
        },
        {
          text: '15:40',
          value: 'slot1540',
        },
        {
          text: '16:20',
          value: 'slot1620',
        },
        {
          text: '17:00',
          value: 'slot1700',
        },
        {
          text: '18:00',
          value: 'slot1800',
        },        
      ];
    },

    getCurrentHost() {
      this.endpoint = window.location.host;
    },

    copyText(text) {
      navigator.clipboard.writeText(text);
      this.snackbar.text = "Copiado al portapapeles";
      this.snackbar.color = "green";
      this.snackbarShow = true;
    },

    getAllowedDates() {
      this.allowedDates = [];
      const today = new Date();
      let todayPlus1 = new Date();
      let todayPlus2 = new Date();
      //let todayPlus3 = new Date();
      todayPlus1.setDate(today.getDate() + 1);
      todayPlus2.setDate(today.getDate() + 2);
      //todayPlus3.setDate(today.getDate() + 3);
      let day = {
        text: new Intl.DateTimeFormat(navigator.language, {
          weekday: "long",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }).format(today),
        value: today.toISOString().split("T")[0],
      };
      this.allowedDates.push(day);

      day = {
        text: new Intl.DateTimeFormat(navigator.language, {
          weekday: "long",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }).format(todayPlus1),
        value: todayPlus1.toISOString().split("T")[0],
      };
      this.allowedDates.push(day);

      day = {
        text: new Intl.DateTimeFormat(navigator.language, {
          weekday: "long",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }).format(todayPlus2),
        value: todayPlus2.toISOString().split("T")[0],
      };
      this.allowedDates.push(day);

      /*
      day = {
        text: new Intl.DateTimeFormat(navigator.language, {
          weekday: "long",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }).format(todayPlus3),
        value: todayPlus3.toISOString().split("T")[0],
      };
      this.allowedDates.push(day);
      */
    },

    getAllowedHours() {
      this.allowedHours = [];
      let i = 0;
      let day = new Date(this.dateSelected).getDay();
      let hours = {};
      // Check if selected date is saturday (5) or sunday (6).
      if (day == 5 || day == 6) {
        // 8 to 14.
        for (i = 8; i <= 14; i++) {
          hours = {
            text:
              String(i).padStart(2, "0") +
              ":00:00 - " +
              String(i + 1).padStart(2, "0") +
              ":00:00",
            value: String(i).padStart(2, "0") + ":00:00",
          };
          this.allowedHours.push(hours);
        }

        // 15 to 17.
        hours = { text: "15:00:00 - 15:40:00", value: "15:00:00" };
        this.allowedHours.push(hours);
        hours = { text: "15:40:00 - 16:20:00", value: "15:40:00" };
        this.allowedHours.push(hours);
        hours = { text: "16:20:00 - 17:00:00", value: "16:20:00" };
        this.allowedHours.push(hours);

        // 17 to 22.
        for (i = 17; i <= 22; i++) {
          hours = {
            text:
              String(i).padStart(2, "0") +
              ":00:00 - " +
              String(i + 1).padStart(2, "0") +
              ":00:00",
            value: String(i).padStart(2, "0") + ":00:00",
          };
          this.allowedHours.push(hours);
        }
      } else {
        for (i = 8; i <= 22; i++) {
          hours = {
            text:
              String(i).padStart(2, "0") +
              ":00:00 - " +
              String(i + 1).padStart(2, "0") +
              ":00:00",
            value: String(i).padStart(2, "0") + ":00:00",
          };
          this.allowedHours.push(hours);
        }
      }
    },

    setLog(data) {
      this.logs.unshift({
        type: data.type,
        msg: data.msg,
        from: data.from,
        title: data.title ? data.title : null,
        timestamp: new Intl.DateTimeFormat(navigator.language, {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
        }).format(new Date()),
      });
    },

    validateForm() {
      this.activeScheduler = false;
      this.delayScheduler = false;
      if (this.$refs.form.validate()) {
        this.formValid = true;
        this.setLog({
          from: "validateForm",
          type: "success",
          msg: "Form Valid",
        });
      } else {
        this.formValid = false;
        this.setLog({
          from: "validateForm",
          type: "warning",
          msg: "Form Not Valid",
        });
      }
    },

    book() {
      if (this.formValid) {
        this.setBooking();
      }
    },

    getHeader() {
      let header = {
        "X-Requested-With": "XMLHttpRequest",
        Country: "AR",
        "App-Id": "hacoaj",
        "App-Os": "web",
        Authorization: this.token,
        "Accept-Language": "es-AR",
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=utf-8",
      };

      return header;
    },

    async login() {
      if (!this.validUsers.includes(this.username)) {
        this.snackbar.color = "red";
        this.snackbar.text =
          "El usuario no tiene permisos para usar CanchaEasy";
        this.snackbarShow = true;
        return;
      }
      
      this.overlayMessage = "Iniciando sesión ...";
      this.bookingLoading = true;
      
      var body = {
        email: this.username,
        password: this.password,
      };
      var header = this.getHeader();
      await axios
        .post("https://" + this.endpoint + "/api/login", body, {
          headers: header,
        })
        .then((response) => {
          if (!response.data.error) {
            this.overlayMessage = "";
            this.bookingLoading = false;            
            this.setLog({ from: "login", type: "success", msg: response.data });
            this.token = response.data.token;
            this.user = VueJwtDecode.decode(this.token);
            this.getUser(this.user.id);
            this.getRelations(this.user.id);
          } else {
            this.overlayMessage = "";
            this.bookingLoading = false;
            this.setLog({
              from: "login",
              type: "warning",
              msg: response.data.msg,
            });          
          }
        })
        .catch((error) => {
          this.overlayMessage = "";
          this.bookingLoading = false;          
          this.setLog({ from: "login", type: "error", msg: error });
        });
    },

    logout() {
      var body = {};
      var header = this.getHeader();
      axios
        .post("https://" + this.endpoint + "/api/users/728660/logout", body, {
          headers: header,
        })
        .then((response) => {
          this.user = null;
          this.token = null;
          if (!response.data.error) {
            this.setLog({
              from: "logout",
              type: "success",
              msg: response.data,
            });
          } else {
            this.setLog({
              from: "logout",
              type: "warning",
              msg: response.data.msg,
            });
          }
        })
        .catch((error) => {
          this.setLog({ from: "logout", type: "error", msg: error });
        });
    },

    async pushToken() {
      var body = {
        token: "ExponentPushToken[jTkJ4XBFnopDcAQ0d_VF-Y]",
        userId: this.user.id,
      };
      var header = this.getHeader();
      console.log("HEADER", header);
      await axios
        .post("https://" + this.endpoint + "/api/users/push-token", body, {
          headers: header,
        })
        .then((response) => {
          this.logs.unshift(response.data);
          if (!response.data.error) {
            this.msg += "<br>" + response.data.msg;
            console.log(response.data);
          } else {
            this.error += "<br>" + response.data.msg;
            console.error(response);
          }
        })
        .catch((error) => {
          this.setLog({ from: "pushToken", type: "error", msg: error });
        });
    },

    getUser(id) {
      var header = this.getHeader();
      axios
        .get("https://" + this.endpoint + "/api/user/" + id, {
          headers: header,
        })
        .then((response) => {
          if (!response.data.error) {
            this.setLog({
              from: "getUser",
              type: "success",
              msg: response.data,
            });
          } else {
            this.setLog({
              from: "getUser",
              type: "warning",
              msg: response.data.msg,
            });
          }
        })
        .catch((error) => {
          this.setLog({ from: "getUser", type: "error", msg: error });
        });
    },

    async getTimeslots(date) {
      var header = this.getHeader();
      let availability = {};
      this.availability = [];
      await axios
        .get(
          "https://" +
            this.endpoint +
            "/api/sports/" +
            this.sport +
            "/clubs/" +
            this.club +
            "/timeslots?date=" +
            date +
            "&time=" +
            this.currentTime +
            "&timespan=40",
          { headers: header }
        )
        .then((response) => {
          if (!response.data.error) {
            // Check if hour is available.
            let courts = [];
            response.data.alternative_timeslots.forEach((avaliableHour) => {
              courts = [];
              avaliableHour.timeslots.forEach((court) => {
                let temp = {
                  court: court.courtId,
                  timespan: court.priceInfo.timespan,
                  start_time: court.local_start_time,
                  end_time: court.local_end_time,
                };
                courts.push(temp);
              });
              availability[avaliableHour.hour] = courts;
            });
            this.availability = availability;
            return availability;
          } else {
            this.setLog({
              from: "getTimeSlots",
              type: "warning",
              msg: response.data.msg,
            });
            return availability;
          }
        })
        .catch((error) => {
          this.setLog({ from: "getTimeSlots", type: "error", msg: error });
          console.log("returning getTimeSlot 3");
          return availability;
        });
    },

    getRelations(id) {
      var header = this.getHeader();
      axios
        .get(
          "https://" +
            this.endpoint +
            "/api/clubs/" +
            this.club +
            "/users/" +
            id +
            "/relationships",
          { headers: header }
        )
        .then((response) => {
          if (!response.data.error) {
            this.setLog({
              from: "getRelations",
              type: "success",
              msg: response.data,
            });
            this.relations = [];
            this.relationsSelected = [];
            response.data.userRelationships.forEach((relation) => {
              this.relations.push({
                value: relation.userId,
                text: relation.firstName + " " + relation.lastName,
              });
              this.relationsSelected.push(relation.userId);
            });
          } else {
            this.setLog({
              from: "getRelations",
              type: "warning",
              msg: response.data.msg,
            });
          }
        })
        .catch((error) => {
          this.setLog({ from: "getRelations", type: "error", msg: error });
        });
    },

    getSchedule(date) {  
      this.getScheduledHeader();
    
      this.lastScheduleGet = new Date().toLocaleString('es-AR', {timeZone: 'America/Buenos_Aires'});
      
      if (this.user) {
        this.overlayMessage = "Buscando reservas ...";
        this.bookingLoading = true;
      }

      var header = this.getHeader();
      axios
        .get(
          "https://" +
            this.endpoint +
            "/api/clubs/" +
            this.club +
            "/sports/" +
            this.sport +
            "/schedule",
          { headers: header, params: { date: date } }
        )
        .then((response) => {
          if (!response.data.error) {
            this.setLog({
              from: "getSchedule",
              type: "success",
              msg: response.data.schedule,
              title: "Date " + date,
            });
            this.scheduledItems = [];
            response.data.schedule.forEach((court) => {
              let scheduledCourts = {};

              scheduledCourts['courtName'] = court.courtText.substring(0, 8);
              court.slots.forEach((slot) => {           
                let group = this.getGroupFromPlayer(slot.players[0]);
                scheduledCourts['slot' + slot.time.substring(0,2) + slot.time.substring(3,5)] = {group: group['group'], color: group['color'], player: slot.players[0]};
              });
              this.scheduledItems.push(scheduledCourts);
            });
          } else {
            this.setLog({
              from: "getSchedule",
              type: "warning",
              msg: response.data.msg,
            });
          }
          this.overlayMessage = "";
          this.bookingLoading = false;          
        })
        .catch((error) => {
          this.overlayMessage = "";
          this.bookingLoading = false;          
          this.setLog({ from: "getSchedule", type: "error", msg: error });
        });
    },

    async setBooking() {
      this.overlayMessage = "Resevando cancha ...";
      this.bookingLoading = true;
      await this.getTimeslots(this.dateSelected);
      this.setLog({
        from: "setBooking",
        type: "success",
        msg: this.availability,
        title: "Available Courts per Hour",
      });
      this.bookingResultMessage = "";

      if (!(this.hourSelected in this.availability)) {
        this.setLog({
          from: "setBooking",
          type: "warning",
          msg: "No available courts for the datetime.",
        });
        this.bookingResultMessage =
          "No se realizó la reserva ya que no hay canchas disponibles para el dia " +
          this.allowedDates.find((date) => date.value === this.dateSelected)
            .text +
          " en el horario de las " +
          this.hourSelected +
          " hs.";
        this.bookingResultDialog = true;
        this.overlayMessage = "";
        this.bookingLoading = false;
        return;
      }

      // Check if court selected is available.
      let found = false;
      this.start_time = "";
      this.end_time = "";
      this.timespan = 0;
      this.availability[this.hourSelected].forEach((item) => {
        if (item.court == this.courtSelected) {
          found = true;
          this.start_time = item.start_time;
          this.end_time = item.end_time;
          this.timespan = item.timespan;
        }
      });
      if (!found) {
        if (this.availability[this.hourSelected].length > 0) {
          // At least there is one available court at the selected time.
          let secondaryCourt = this.availability[this.hourSelected][0].court;
          this.start_time = this.availability[this.hourSelected][0].start_time;
          this.end_time = this.availability[this.hourSelected][0].end_time;
          this.timespan = this.availability[this.hourSelected][0].timespan;
          this.setLog({
            from: "setBooking",
            type: "warning",
            msg:
              "Court selected " +
              this.courtSelected +
              " not available for the datetime, using a secondary court " +
              secondaryCourt,
          });
          this.courtSelected = secondaryCourt;
        } else {
          this.setLog({
            from: "setBooking",
            type: "warning",
            msg: "No available courts for the datetime.",
          });
          this.bookingResultMessage =
            "No se realizó la reserva ya que no hay canchas disponibles para el dia " +
            this.allowedDates.find((date) => date.value === this.dateSelected)
              .text +
            " en el horarios de las " +
            this.hourSelected +
            " hs.";
          this.bookingResultDialog = true;
          this.overlayMessage = "";
          this.bookingLoading = false;
          return;
        }
      }

      var body = {
        clubId: this.club,
        sportId: this.sport,
        courtId: this.courtSelected,
        date: this.dateSelected,
        time: this.start_time,
        timespan: this.timespan,
        action: "book",
        comments: null,
        dataConfigValues: {},
        bookUserIds: [
          {
            userId: this.user.id,
            ancillaries: {
              total: 0,
              totalOnlinePayment: 0,
              totalOnlinePayment_formatted: "$ 0,00",
              totalOfflinePayment: 0,
              totalOfflinePayment_formatted: "$ 0,00",
              items: {},
            },
          },
          {
            userId: this.relationsSelected[0],
            ancillaries: {
              total: 0,
              totalOnlinePayment: 0,
              totalOnlinePayment_formatted: "$ 0,00",
              totalOfflinePayment: 0,
              totalOfflinePayment_formatted: "$ 0,00",
              items: {},
            },
          },
          {
            userId: this.relationsSelected[1],
            ancillaries: {
              total: 0,
              totalOnlinePayment: 0,
              totalOnlinePayment_formatted: "$ 0,00",
              totalOfflinePayment: 0,
              totalOfflinePayment_formatted: "$ 0,00",
              items: {},
            },
          },
          {
            userId: this.relationsSelected[2],
            ancillaries: {
              total: 0,
              totalOnlinePayment: 0,
              totalOnlinePayment_formatted: "$ 0,00",
              totalOfflinePayment: 0,
              totalOfflinePayment_formatted: "$ 0,00",
              items: {},
            },
          },
        ],
        insuranceInformation: {
          playerCount: null,
          amountTotal: null,
          planCode: null,
        },
        isElegibleForCrossBlock: false,
      };

      var header = this.getHeader();
      this.overlayMessage = "Reservando cancha ...";
      this.bookingLoading = true;
      let payload = {
        userId: this.user.id,
        date: this.dateSelected,
        startTime: this.start_time,
        endTime: this.end_time,
      };

      await axios
        .post(
          "https://" +
            this.endpoint +
            "/api/clubs/" +
            this.club +
            "/sports/" +
            this.sport +
            "/courts/" +
            this.courtSelected +
            "/block",
          payload,
          { headers: header }
        )
        .then((response) => {
          if (!response.data.error) {
            this.setLog({
              from: "setBooking",
              type: "success",
              msg: response.data,
              title: "Court blocked",
            });
            axios
              .post(
                "https://" +
                  this.endpoint +
                  "/api/clubs/" +
                  this.club +
                  "/sports/" +
                  this.sport +
                  "/courts/" +
                  this.courtSelected +
                  "/bookingsv2",
                body,
                { headers: header }
              )
              .then((response) => {
                if (!response.data.error) {
                  this.setLog({
                    from: "setBooking",
                    type: "success",
                    msg: response.data,
                  });
                  this.bookingLoading = false;
                  this.snackbar.color = "green";
                  this.snackbar.text = "Su reserva fue generada con éxito";
                  this.snackbarShow = true;
                  this.bookingResultMessage =
                    "Adentro " +
                    this.courts.find((court) => court.id === this.courtSelected)
                      .name +
                    " el " +
                    this.allowedDates
                      .find((date) => date.value === this.dateSelected)
                      .text.split(" ")[0] +
                    " " +
                    this.hourSelected.substring(0, 2) +
                    "hs.";
                  this.bookingResultDialog = true;
                  this.overlayMessage = "";
                  this.bookingLoading = false;
                } else {
                  this.setLog({
                    from: "setBooking",
                    type: "warning",
                    msg: response.data.msg,
                  });
                  this.bookingLoading = false;
                  this.snackbar.color = "red";
                  this.snackbar.text =
                    "Hubo un problema con su reserva ... revise los Logs";
                  this.snackbarShow = true;
                  this.bookingResultMessage =
                    "Hubo un problema con su reserva ... revise los Logs";
                  this.bookingResultDialog = true;
                  this.overlayMessage = "";
                  this.bookingLoading = false;
                }
                // Clear selections.
                this.courtSelected = null;
                this.activeScheduler = false;
                this.delayScheduler = false;
                this.validateForm();
              })
              .catch((error) => {
                this.setLog({ from: "setBooking", type: "error", msg: error });
                this.bookingLoading = false;
                this.snackbar.color = "red lighten-2";
                this.snackbar.text =
                  "Hubo un problema con su reserva ... revise los Logs";
                this.snackbarShow = true;
                this.bookingResultMessage =
                  "Hubo un problema con su reserva ... revise los Logs";
                this.bookingResultDialog = true;
                this.overlayMessage = "";
                this.bookingLoading = false;
              });
          } else {
            this.setLog({
              from: "setBooking",
              type: "error",
              msg: response.data,
              title: "Court blocked",
            });
            this.bookingLoading = false;
            this.snackbar.color = "red lighten-2";
            this.snackbar.text =
              "Hubo un problema con su reserva ... revise los Logs";
            this.snackbarShow = true;
            this.bookingResultMessage =
              "Hubo un problema con su reserva ... revise los Logs";
            this.bookingResultDialog = true;
            this.overlayMessage = "";
            this.bookingLoading = false;
          }
        })
        .catch((error) => {
          this.setLog({ from: "setBooking", type: "error", msg: error });
          this.bookingLoading = false;
          this.snackbar.color = "red lighten-2";
          this.snackbar.text =
            "Hubo un problema con su reserva ... revise los Logs";
          this.snackbarShow = true;
          this.bookingResultMessage =
            "Hubo un problema con su reserva ... revise los Logs";
          this.bookingResultDialog = true;
          this.overlayMessage = "";
          this.bookingLoading = false;
        });
    },

    getAllUsers() {
      this.showAllUsers = true;
      this.overlayMessage = "Buscando a todos los usuarios ...";
      this.bookingLoading = true;

      var header = this.getHeader();
      axios
        .get(
          "https://" +
            this.endpoint +
            "/api/clubs/" +
            this.club +
            "/users/" +
            this.userId +
            "/sports/" +
            this.sport +
            "/all-users",
          { headers: header }
        )
        .then((response) => {
          if (!response.data.error) {
            this.setLog({
              from: "getAllUsers",
              type: "success",
              msg: response.data.users
            });
            this.allUsers = [];
            response.data.users.forEach((user) => {
              this.allUsers.push({id: user.id, name: user.userFullName});
            });
          } else {
            this.setLog({
              from: "getAllUsers",
              type: "warning",
              msg: response.data.msg,
            });
          }
          this.overlayMessage = "";
          this.bookingLoading = false;         
        })
        .catch((error) => {
          this.overlayMessage = "";
          this.bookingLoading = false;          
          this.setLog({ from: "getAllUsers", type: "error", msg: error });
        });

    },

    getPastBookings(userID, year, month) {
      //this.showAllUsers = true;
      //this.overlayMessage = "Buscando a todos los usuarios ...";
      //this.bookingLoading = true;

      var header = this.getHeader();
      axios
        .get(
          "https://" +
            this.endpoint +
            "/api/user/" +
            userID +
            "/past_bookings?year=" +
            year +
            "&month=" +
            month +
            "&actual_page=1&books_per_page=99",
          { headers: header }
        )
        .then((response) => {
          if (!response.data.error) {
            this.setLog({
              from: "getPastBookings",
              type: "success",
              msg: response.data.bookings
            });
            //this.allUsers = [];
            //response.data.users.forEach((user) => {
              //this.allUsers.push({id: user.id, name: user.userFullName});
            //});
          } else {
            this.setLog({
              from: "getPastBookings",
              type: "warning",
              msg: response.data.msg,
            });
          }
          //this.overlayMessage = "";
          //this.bookingLoading = false;         
        })
        .catch((error) => {
          this.overlayMessage = "";
          this.bookingLoading = false;          
          this.setLog({ from: "getPastBookings", type: "error", msg: error });
        });

    },    

    getGroups() {
      this.groups = gjson
    },

    getGroupFromPlayer(player) {
      let group = this.playersGroups.find((g) => g.player === player);
      if (group) {
        return group;
      } else {
        return {player: player, groupDesc: "Sin grupo", group: "??", color: "black"};
      }
    },

    getPlayersFromGroup(group) {
      let players = [];
      this.playersGroups.forEach(player => {
        if (player.group == group) {
          players.push(player.player);
        }
      });

      return players;
    },

    setPlayersGroups() {
      this.playersGroups = gpjson;
    },

    formatDate(date) {
      let d = new Date(date + "T00:00:00");
      let formatted =  new Intl.DateTimeFormat(navigator.language, {
            weekday: "long",
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }).format(d);
      return formatted;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
